export default function LinkTypeBadge({ type }: { type: string }) {
  const label =
    type === 'FS' ? 'Finish-Start' :
    type === 'SS' ? 'Start-Start' :
    type === 'FF' ? 'Finish-Finish' :
    'Start-Finish';
  return (
    <span className="inline-flex items-center gap-1 bg-[#F3F4F6] text-[#6B7280] text-[10px] font-bold px-1.5 py-0.5 rounded-md uppercase tracking-wide">
      {label}
    </span>
  );
}